import { axiosSwagger } from "@/axios";


function getUserDeliveryUnitId() {
  const userData =
    localStorage.getItem("USER") &&
    JSON.parse(localStorage.getItem("USER"));

  return userData?.deliveryUnit?.id;
}


export const state = {
  notifications: [],
  loading: false
}
  
export const getters = {
  all: state => [...state.notifications].sort((a, b) => b.id - a.id),

  unread: state =>
    state.notifications.filter(n => !n.seen),

  unreadCount: (state, getters) =>
    getters.unread.length,

  systemCount: state =>
    state.notifications.filter(n => n.type?.toLowerCase() === "system").length,

  aiCount: state =>
    state.notifications.filter(n => n.type?.toLowerCase() === "ai").length
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },

  SET_NOTIFICATIONS(state, data) {
    state.notifications = data;
  },

  MARK_SEEN(state, id) {
    const item = state.notifications.find(n => n.id === id);
    if (item) item.seen = true;
  },

  MARK_ALL_SEEN(state) {
    state.notifications.forEach(n => (n.seen = true));
  },

  REMOVE_NOTIFICATION(state, id) {
    state.notifications = state.notifications.filter(n => n.id !== id);
  },

  CLEAR_ALL(state) {
    state.notifications = [];
  }
}

export const actions = {
  async fetchMyNotifications({ commit }) {
    commit("SET_LOADING", true);

    const deliveryUnitId = getUserDeliveryUnitId();

    try {
      const res = await axiosSwagger.get(
        `/Core/Notification/My/${deliveryUnitId}`
      );
      commit("SET_NOTIFICATIONS", res.data);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async markAsSeen({ commit }, id) {
    await axiosSwagger.put(`/Core/Notification/Seen/${id}`);
    commit("MARK_SEEN", id);
  },

  async markAllAsSeen({ commit }) {
    const deliveryUnitId = getUserDeliveryUnitId();

    await axiosSwagger.post(`/Core/Notification/Clear/${deliveryUnitId}`);
    commit("MARK_ALL_SEEN");
  },

  async removeNotification({ commit }, id) {
    await axiosSwagger.post(`/Core/Notification/Remove/${id}`);
    commit("REMOVE_NOTIFICATION", id);
  },

  async clearAll({ commit }) {
    const deliveryUnitId = getUserDeliveryUnitId();

    await axiosSwagger.post(`/Core/Notification/Clear/${deliveryUnitId}`);
    commit("CLEAR_ALL");
  },

  async addNotification({ commit, dispatch, state }, id) {
    const res = await axiosSwagger.get(`/Core/Notification/${id}`);
    const notification = res.data;

    // If the notification is related to AI file indexing, refresh the uploads list and open the panel
    if(notification.type?.toLowerCase() === 'ai'){
      await dispatch("aiFileManager/smartUpload/reFetchUploads", null, { root: true });
    }

    commit("SET_NOTIFICATIONS", [notification, ...state.notifications]);
  }
}
